<button (click)="toggle()" class="button-ghost-gray h-34px">
    {{ language() }}
    <companyid-chevron color="black" position="bottom" smallSize />
</button>
@if (isShown()) {
    <ul
        companyidClickOutside
        (onClickOutside)="toggle()"
        class="z-50 absolute text-medium-regular text-primary-text-color rounded-6px box-shadow-2 p-5px bg-white w-230px mt-2"
    >
        @for (locale of locales; track locale.label) {
            <li
                aria-hidden="true"
                class="hover:bg-gray-2 hover:text-dark-4 w-full px-15px py-2 cursor-pointer h-[40px]"
                (click)="chooseLanguage(locale)"
            >
                {{ locale.label }}
            </li>
        }
    </ul>
}
